<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="container mainContent">
  <div class="row unselectable headerTitle headline">{{translation.WheelNews}}</div>
  <div class="breakLine"></div>
  <div id="moduleContent" class="row unselectable">
    <app-module *ngIf="wheelnewsTaskModule != null" class="cotraModuleCard col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" [module]="wheelnewsTaskModule" (click)="navigate(wheelnewsTaskModule.ForwardLink)"></app-module>
    <app-module *ngIf="wheelnewsOrderviewModule != null" class="cotraModuleCard col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" [module]="wheelnewsOrderviewModule" (click)="navigate(wheelnewsOrderviewModule.ForwardLink)"></app-module>
  </div>
</div>
<app-footer></app-footer>
